/* eslint-disable no-undef */

import React from 'react';
import { TouchableOpacity, Platform, View, Text, Image } from 'react-native';
import styles from '../InternalComponents/styles/style';
import Autocomplete from '../../components/customAutoComplete';
import { getResponsiveStyle } from '../../utils/appUtils';
import AsyncStorage from '@react-native-community/async-storage';
import {
  ALL_CONSTANTS,
} from '../../constants/displayConstants';
import {
  CSR,
  getService
} from '../../network/request/apirequests.js';
import ApiTag from '../../network/request/apiTags';

export default class Topsection extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      valueSelected: '',
      searchFlag: true,
      searchArray: '',
      searchAll: true,
      stateId: 1,
      userIdle: true
    };
    this.makeAPICall = props.makeAPICall;
  }
  componentDidMount() {
    let id = 1;
    const pathName = window.location.pathname;
    this.fetchIpLocation();

    switch (true) {
      case pathName.includes(ALL_CONSTANTS.PROFILE_PATH):
        id = 1;
        this.state.searchAll = false;
        break;
      case pathName.includes(ALL_CONSTANTS.ACCOUNT_PATH):
        id = 2;
        this.state.searchAll = false;
        break;
      case pathName.includes(ALL_CONSTANTS.CREDIT_CARD_PATH):
        id = 3;
        this.state.searchAll = false;
        break;
      case pathName.includes(ALL_CONSTANTS.LOAN_PATH):
        id = 4;
        this.state.searchAll = false;
        break;
      case pathName.includes(ALL_CONSTANTS.DEPOSITS_PATH):
        id = 5;
        this.state.searchAll = false;
        break;
      case pathName.includes(ALL_CONSTANTS.INVESTMENT_PRODUCT_PATH):
        id = 7;
        this.state.searchAll = false;
        break;
      case pathName.includes(ALL_CONSTANTS.FOREX_PATH):
        id = 8;
        this.state.searchAll = false;
        break;
      case pathName.includes(ALL_CONSTANTS.ATMDEBIT_PATH):
        id = 9;
        this.state.searchAll = false;
        break;
      default:
        null;
    }
    this.state.stateId = id;
    this.getservicelist();

  }
  componentWillReceiveProps(newprops) {
    if (this.props.isSearch) {
      this.setState({
        searchFlag: false
      });
    }

  }
  fetchIpLocation() {
    fetch('https://api.ipify.org?format=json')
      .then(response => response.json())
      .then(data => {
        this.setState({
          userIp: data.ip
        });
        //sessionStorage.setItem('userIp', data.ip);
      })
      .catch(error => this.setState({ userIp: 0 }));
  }

  componentWillReceiveProps(newprops) { }
  onSubmit = async () => {
    this.setState({ searchFlag: true });
  };

  gotOService = async data => {
    this.props.navigation.state.params = {};
    this.props.navigation.state.params.flow = data.servicename;
    this.props.navigation.state.params.serviceType = data.serviceType;
    this.props.navigation.state.params.servicename = data.servicename;
    this.props.navigation.state.params.serviceDynamic = data.dynamicStatus;
    this.props.navigation.state.params.menuType = data.menuType;
    this.props.navigation.state.params.menuname = data.menuType;
    this.props.navigation.state.params.serviceMessageForNoDynamic =
      data.message;

    this.props.navigation.state.params.flag = true;

    if (Platform.OS === 'web') {
      sessionStorage.setItem('flag', 'true');
    } else {
      await AsyncStorage.setItem('flag', 'true');
    }
    this.props.navigation.navigate(
      'Verification',
      this.props.navigation.state.params
    );
  };


  getservicelist = id => {
    var that = this;
    var fieldData = {};
    if (this.state.searchAll == true) {
      fieldData = {
        number: 'high',
        dynamicSearch: "false"
      };
    } else {
      fieldData = {
        number: this.state.stateId,
        dynamicSearch: "true"
      };
    }
    this.makeAPICall(
      getService(fieldData, CSR),
      this.onDataReceived,
      this.onError
    );
  };

  onDataReceived = response => {
    this.setState({ loading: false });
    var that = this;
    if (ApiTag.DEACTIVATE_TOKEN == response.tag) {
      if (response.data.status === 200) {
      }
    } else if (ApiTag.GETSERVICE == response.tag) {
      let array = [];
      for (let i = 0; i < response.data.data.length; i += 1) {
        if (response.data.data[i]['images'] === null) {
          var ServiceImages = require('../../assets/images/icon_email.png');
        } else {
          var ServiceImages = response.data.data[i]['images'];
        }
        let dataArray = [];
        Object.keys(response.data.data[i]).map((key, val, item) => {
          dataArray = {
            id: response.data.data[i]['servicename'],
            serviceId: response.data.data[i]['serviceId'],
            servicename: response.data.data[i]['servicename'],
            title: response.data.data[i]['servicename'],
            serviceType: response.data.data[i]['serviceType'],
            images: ServiceImages,
            dynamicStatus: response.data.data[i]['dynamicStatus'],
            menuname: response.data.data[i]['menuname'],
            dynamicMessage: response.data.data[i]['message'],
            dynamicMenuType: response.data.data[i]['menuType'],
            keywordSearch: response.data.data[i]['keywordSearch'],
            displayName: response.data.data[i]['displayMessage'],
            timeFlag: response.data.data[i]['timeFlag'],
          };
        });
        array.push(dataArray);
      }
      this.setState({
        searchArray: array
      });
    }
  };
  render() {
    let props = this.props;
    const { measure, headerFlag } = props;
    return (
      <View
        style={[
          styles.TopsectionMainView,
          styles[getResponsiveStyle('TopsectionMainView', measure)]
        ]}
      >
        {/* <View style={[
                    styles.TopsectionsecondView,
                    styles[getResponsiveStyle('TopsectionsecondView', measure)],
                ]}>
                    <View style={[
                        styles.TopsectionInnerView,
                        styles[getResponsiveStyle('TopsectionInnerView', measure)],
                    ]}>
                        <Text style={[
                            styles.TopsectionTextStyle,
                            styles[getResponsiveStyle('TopsectionTextStyle', measure)],
                        ]} >Service Requests</Text>
                    </View>

                    {measure === 'LDPI' || measure === 'MDPI' || measure === 'HDPI' || measure === 'XHDPI' ? (
                        null
                    ) : (
                            <View style={[
                                styles.TopsectionAutocompleteView,
                                styles[getResponsiveStyle('TopsectionAutocompleteView', measure)],
                            ]} >
                                <View style={[
                                    styles.TopsectionAutocompleteView2,
                                    styles[getResponsiveStyle('TopsectionAutocompleteView2', measure)],
                                ]} >
                                    <View style={[
                                        styles.TopsectionAutocompleteView3,
                                        styles[getResponsiveStyle('TopsectionAutocompleteView3', measure)],
                                    ]} >
                                        <Autocomplete
                                            measure={measure}
                                            autoCapitalize='none'
                                            searchIcon={true}
                                            autoCorrect={false}
                                            hideResults={props.CloseSelectionDropdown}
                                            inputContainerStyle={{
                                                borderBottomWidth: null,
                                                borderBottomColor: 'transparent',
                                            }}
                                            style={[
                                                styles.TopsectionAutocompletestyle,
                                                styles[getResponsiveStyle('TopsectionAutocompletestyle', measure)],
                                            ]}
                                            data={props.SearchElements}
                                            value={props.SelectedDropdownOption}
                                            onChangeText={(text) => { props.searchOptionChange(text); }}
                                            placeholder={"'How can we help you?"}
                                            renderItem={(val) => (
                                                <TouchableOpacity
                                                    style={[
                                                        styles.TopsectionAutocompleteButtonstyle,
                                                        styles[getResponsiveStyle('TopsectionAutocompleteButtonstyle', measure)],
                                                    ]}
                                                    onPress={() => {
                                                        props.textInputChange(val.optionname.toUpperCase());
                                                    }}
                                                >
                                                    <Text
                                                        style={[
                                                            styles.TopsectionAutocompleteButtontextstyle,
                                                            styles[getResponsiveStyle('TopsectionAutocompleteButtontextstyle', measure)],
                                                        ]}
                                                    >
                                                        {val.optionname.toUpperCase()}
                                                    </Text>
                                                </TouchableOpacity>
                                            )}
                                        />
                                    </View>
                                </View>
                            </View>
                        )}
                    <View style={[
                        styles.TopsectionthirdtextView,
                        styles[getResponsiveStyle('TopsectionthirdtextView', measure)],
                    ]} >
                        <TouchableOpacity style={[
                            styles.TopsectionthirdtextView2,
                            styles[getResponsiveStyle('TopsectionthirdtextView2', measure)],
                        ]} >
                            <Image
                                style={[
                                    styles.TopsectionAutocompleteIMagestyle,
                                    styles[getResponsiveStyle('TopsectionAutocompleteIMagestyle', measure)],
                                ]}
                                resizeMode='contain'
                                source={require('../../assets/images/26-Smartphone-Status.png')}
                            />
                        </TouchableOpacity>
                    </View>
                </View> */}
        {measure === 'LDPI' ||
          measure === 'MDPI' ||
          measure === 'HDPI' ||
          measure === 'XHDPI' ? (
          <View
            style={[
              styles.TopsectionAutocompleteView,
              styles[getResponsiveStyle('TopsectionAutocompleteView', measure)]
            ]}
          >
            <View
              style={[
                styles.TopsectionAutocompleteView2,
                styles[
                getResponsiveStyle('TopsectionAutocompleteView2', measure)
                ]
              ]}
            >
              {this.state.searchFlag === false ?
                headerFlag ?
                  (
                    <View style={{ width: '100%', flexDirection: 'row' }}>
                      <View style={{ flex: 2 }}>
                        {/* <Slider {...settings}>
                          <View
                            style={{
                              flexDirection: 'row',
                              width: '100%'
                            }}
                          > */}
                        <View style={{ flex: 1 }}>
                          {/* <Image
                              style={{
                                width: 10,
                                height: 10
                              }}
                              resizeMode='contain'
                              source={require('../../assets/images/searchicon.png')}
                            /> */}
                        </View>
                        {/* <View style={{ flex: 2 }}>
                              <TouchableOpacity
                                onPress={() => this.gotOService(Data[0])}
                              >
                                <Text>{Data[0].servicename}</Text>
                              </TouchableOpacity>
                            </View>
                          </View>
                          <View>
                            <TouchableOpacity
                              onPress={() => this.gotOService(Data[1])}
                            >
                              <Text>{Data[1].servicename}</Text>
                            </TouchableOpacity>
                          </View>
                          <View>
                            <TouchableOpacity
                              onPress={() => this.gotOService(Data[2])}
                            >
                              <Text>{Data[2].servicename}</Text>
                            </TouchableOpacity>
                          </View>
                          <View>
                            <TouchableOpacity
                              onPress={() => this.gotOService(Data[3])}
                            >
                              <Text>{Data[3].servicename}</Text>
                            </TouchableOpacity>
                          </View>
                          <View>
                            <TouchableOpacity
                              onPress={() => this.gotOService(Data[4])}
                            >
                              <Text>{Data[4].servicename}</Text>
                            </TouchableOpacity>
                          </View>
                        </Slider> */}
                      </View>
                      <View
                        style={{
                          paddingHorizontal: '5%',
                          zIndex: -9,
                          width: '10%',
                          marginTop: '1%'
                        }}
                      >
                        <TouchableOpacity onPress={() => this.onSubmit()}>
                          <Image
                            style={{
                              width: 20,
                              height: 20
                            }}
                            resizeMode='contain'
                            source={require('../../assets/images/searchicon.png')}
                          />
                        </TouchableOpacity>
                      </View>
                    </View>) : null : (
                  <View
                    style={[
                      styles.TopsectionAutocompleteView3,
                      styles[
                      getResponsiveStyle('TopsectionAutocompleteView3', measure)
                      ]
                    ]}
                  >
                    <TouchableOpacity onPress={() => this.onSubmit()}>
                      <Image
                        style={{
                          width: 20,
                          height: 20,
                          marginRight: 10
                        }}
                        resizeMode='contain'
                        source={require('../../assets/images/searchicon.png')}
                      />
                    </TouchableOpacity>
                    <View style ={{width:'90%'}}>
                    <Autocomplete
                      measure={measure}
                      autoCapitalize='none'
                      autoCorrect={false}
                      searchIcon={true}
                      hideResults={props.CloseSelectionDropdown}
                      inputContainerStyle={{
                        borderBottomWidth: null,
                        borderBottomColor: 'transparent',
                        width: measure === 'LDPI' ? 270 :
                          measure === 'MDPI' ? 310 :
                            measure === 'HDPI' || measure === 'XHDPI' ? 320 : 300
                      }}
                      style={[
                        styles.TopsectionAutocompletestyle,
                        styles[
                        getResponsiveStyle(
                          'TopsectionAutocompletestyle',
                          measure
                        )
                        ]
                      ]}
                      data={props.SearchElements}
                      value={props.SelectedDropdownOption}
                      onChangeText={text => {
                        props.searchOptionChange(text);
                      }}
                      placeholder={'Search for service request...'}
                      renderItem={val => (
                        <TouchableOpacity
                          style={[
                            styles.TopsectionAutocompleteButtonstyle,
                            styles[
                            getResponsiveStyle(
                              'TopsectionAutocompleteButtonstyle',
                              measure
                            )
                            ]
                          ]}
                          onPress={() => {
                            props.textInputChange(
                              val.optionname.toUpperCase(),
                              val
                            );
                          }}
                        >
                          <Text
                            style={[
                              styles.TopsectionAutocompletemenutextstyle,

                              styles[
                              getResponsiveStyle(
                                'TopsectionAutocompletemenutextstyle',
                                measure
                              )
                              ]
                            ]}
                          >
                            {val.dynamicMenuType.toUpperCase()}-
                          </Text>
                          <Text
                            style={[
                              styles.TopsectionAutocompleteButtontextstyle,
                              styles[
                              getResponsiveStyle(
                                'TopsectionAutocompleteButtontextstyle',
                                measure
                              )
                              ]
                            ]}
                          >
                            {val.optionname.toUpperCase()}
                          </Text>
                        </TouchableOpacity>
                      )}
                    />
                  </View>
                  </View>
                )} 
            </View>
          </View>
        ) : null}
      </View>
    );
  }
}
